import { render, staticRenderFns } from "./notifications-dropdown.vue?vue&type=template&id=0ef55588&lang=html&"
import script from "./notifications-dropdown.vue?vue&type=script&lang=js&"
export * from "./notifications-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports